export default __webpack_public_path__ + "static/media/Arielle_Nissenblatt_AHV_In_Moms_We_Trust.a06286be.jpg";